import { useCodeScript, useUrlScript } from '@/hooks/use-script'
import { getGaTrackingId } from '@/utils/env'

export const useAnalyticsScripts = () => {
	const gaTrackingId = getGaTrackingId()

	useUrlScript(`https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`, 'head')

	useCodeScript(`
			window.dataLayer = window.dataLayer || []

			function gtag() {
				dataLayer.push(arguments)
			}

			gtag('js', new Date())

			gtag('config', '${gaTrackingId}', {
				custom_map: {
					dimension0: 'reservation_channel'
				}
			})

			window.gtag = gtag
		`, 'head')

	useCodeScript(`(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
	ga('create', '${gaTrackingId}', 'auto');
	window.ga = ga;`, 'head')
}
